import { notification } from "antd";
import * as CryptoJS from "crypto-js";
import { Buffer } from "buffer";

const wait = async (timeout) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, timeout);
  });
};

const Notify = (type, title, description) => {
  notification.open({
    type,
    duration: 2,
    message: title,
    description,
  });
};

const base64url = (source) => {
  let encodedSource;
  encodedSource = CryptoJS.enc.Base64.stringify(source);
  encodedSource = encodedSource.replace(/=+$/, "");
  encodedSource = encodedSource.replace(/\+/g, "-");
  encodedSource = encodedSource.replace(/\//g, "_");
  return encodedSource;
};

const generateJWTToken = (
  appId,
  tenantId,
  role,
  scope,
  userId,
  groupIds,
  tokenSecret
) => {
  var header = {
    alg: "HS256",
    typ: "JWT",
  };

  var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  var encodedHeader = base64url(stringifiedHeader);

  var data = {
    iat: 1714148554,
    app_id: appId,
    tenant_id: tenantId,
    user_id: userId,
    //group_id: groupIds,
    roles: role,
    scope: scope,
  };

  var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  var encodedData = base64url(stringifiedData);
  // let apiJson = DataConstants.getSettings();
  var token = encodedHeader + "." + encodedData;
  var secret = Buffer.from(tokenSecret, "base64").toString();

  var signature = CryptoJS.HmacSHA256(token, secret);
  signature = base64url(signature);

  var signedBearerToken = token + "." + signature;
  return signedBearerToken;
};

const CoreUtilities = {
  wait,
  Notify,
  generateJWTToken,
};

export default CoreUtilities;
